export const SET_MASTER_COMPANY_DATA_PAGE = "SET_MASTER_COMPANY_DATA_PAGE";
export const SET_MASTER_COMPANY_DATA_FORM = "SET_MASTER_COMPANY_DATA_FORM";

export const RESET_FORM = "RESET_FORM";

export const SET_ARCHIVE_STATUS = "SET_ARCHIVE_STATUS";

//test
